import React, { useState } from 'react';

const S = {
  page:     { minHeight:'100vh', background:'#F5F6FA', display:'flex', alignItems:'center', justifyContent:'center' },
  card:     { background:'white', borderRadius:20, padding:36, width:380, boxShadow:'0 4px 24px rgba(0,0,0,0.08)', border:'1px solid #E4EDE8' },
  logo:     { textAlign:'center', fontSize:24, fontWeight:800, color:'#0D1F1A', marginBottom:6 },
  logoSpan: { color:'#075E54' },
  sub:      { textAlign:'center', fontSize:13, color:'#7A8F89', marginBottom:28 },
  field:    { marginBottom:16 },
  label:    { display:'block', fontSize:11, fontWeight:700, color:'#7A8F89', textTransform:'uppercase', letterSpacing:0.5, marginBottom:6 },
  input:    { width:'100%', background:'#F0F4F0', border:'1.5px solid #E4EDE8', borderRadius:12, padding:'11px 14px', fontSize:14, color:'#0D1F1A', outline:'none', fontFamily:'inherit', boxSizing:'border-box' },
  inputFocus:{ borderColor:'#075E54' },
  btn:      { width:'100%', background:'linear-gradient(135deg,#075E54,#128C7E)', color:'white', border:'none', borderRadius:12, padding:14, fontSize:15, fontWeight:700, cursor:'pointer', fontFamily:'inherit', marginTop:8 },
  error:    { background:'#FCEBEB', border:'1px solid #F09595', borderRadius:10, padding:'10px 14px', fontSize:12, color:'#A32D2D', marginBottom:16, textAlign:'center' },
  footer:   { textAlign:'center', fontSize:11, color:'#7A8F89', marginTop:20 },
};

export default function Login({ onLogin }) {
  const [usuario,   setUsuario]   = useState('');
  const [password,  setPassword]  = useState('');
  const [error,     setError]     = useState('');
  const [cargando,  setCargando]  = useState(false);

  const API = 'https://api.whatmarket.pixcovery.mx';

async function handleLogin() {
    if (!usuario.trim() || !password.trim()) {
      setError('Completa usuario y contraseña');
      return;
    }
    setCargando(true);
    try {
      const res  = await fetch(`${API}/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ usuario, password }),
      });
      const data = await res.json();
      if (!res.ok || !data.ok) {
        setError('Usuario o contraseña incorrectos');
        return;
      }
      localStorage.setItem('wm_admin_auth', 'true');
      localStorage.setItem('wm_admin_user', JSON.stringify(data.usuario));
      onLogin();
    } catch (err) {
      setError('Error de conexión. Intenta de nuevo.');
    } finally {
      setCargando(false);
    }
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter') handleLogin();
  }

  return (
    <div style={S.page}>
      <div style={S.card}>
        <div style={S.logo}><span style={S.logoSpan}>What</span>Market</div>
        <div style={S.sub}>Panel de administración</div>

        {error && <div style={S.error}>⚠️ {error}</div>}

        <div style={S.field}>
          <label style={S.label}>Usuario</label>
          <input
            style={S.input}
            placeholder="admin"
            value={usuario}
            onChange={e => { setUsuario(e.target.value); setError(''); }}
            onKeyDown={handleKeyDown}
            autoFocus
          />
        </div>
        <div style={S.field}>
          <label style={S.label}>Contraseña</label>
          <input
            style={S.input}
            type="password"
            placeholder="••••••••"
            value={password}
            onChange={e => { setPassword(e.target.value); setError(''); }}
            onKeyDown={handleKeyDown}
          />
        </div>
        <button style={{ ...S.btn, opacity: cargando ? 0.7 : 1 }} onClick={handleLogin} disabled={cargando}>
          {cargando ? '⏳ Verificando...' : '→ Entrar'}
        </button>
        <div style={S.footer}>ctrl.pixventa.com</div>
      </div>
    </div>
  );
}